import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcbasicModule } from './fcbasic/index.module';
import { FcadModule } from './fcad/index.module';
import { FclayoutModule } from './fclayout/index.module';
import { FclistModule } from './fclist/index.module';
import { FcmodalModule } from './fcmodal/index.module';
import { FcnavModule } from './fcnav/index.module';
import { FcprogressModule } from './fcprogress/index.module';
import { FctlbModule } from './fctlb/index.module';
import { FcshareModule } from './fcshare.modal';
import { FcchartModule } from './fcchart/index.module';
const cpms = [
  FcshareModule,
  FcadModule,
  FcbasicModule,
  FclayoutModule,
  FclistModule,
  FcmodalModule,
  FcnavModule,
  FcprogressModule,
  FctlbModule,
  FcchartModule
];
@NgModule({
  imports: cpms,
  exports: cpms,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FccomponentModule { }
export * from './business/fcany.business';
export * from './business/fcchosen.business';
export * from './business/fccombo.business';
export * from './business/fcedit.business';
export * from './business/fcevent.event';
export * from './business/fclistdata.business';
export * from './business/fcmany.business';
export * from './business/fcmodel.business';
export * from './business/fcnavbar.business';
export * from './business/fcnavtab.business';
export * from './business/fctree.business';
export * from './f';
export * from './fc';
export * from './fcinput';
export * from './fcshare.modal';
export * from './grand.component';
export * from './parentdetail.component';
export * from './parentlist.component';
export * from './parentedit.component';

export * from './fclist';
export * from './fcgrand';
export * from './fcdetail';
export * from './fcdetail';

export * from './fcad/index.module';
export * from './fcad/fcadform.component';
export * from './fcad/fcaddetail.component';
export * from './fcad/fcadcarousel.component';
export * from './fcad/fcadprint.component';

export * from './fcbasic/index.module';
export * from './fcbasic/fcany.component';
export * from './fcbasic/fcavatar.component';
export * from './fcbasic/fcbacktop.component';
export * from './fcbasic/fcbadge.component';
export * from './fcbasic/fcbutton.component';
export * from './fcbasic/fccalendar.component';
export * from './fcbasic/fccarousel.component';
export * from './fcbasic/fccascader.component';
export * from './fcbasic/fccheck.component';
export * from './fcbasic/fcchosen.component';
export * from './fcbasic/fccombo.component';
export * from './fcbasic/fcdate.component';
export * from './fcbasic/fcdatetime.component';
export * from './fcbasic/fcdivider.component';
export * from './fcbasic/fcdouble.component';
export * from './fcbasic/fcfastposition.component';
export * from './fcbasic/fcicon.component';
export * from './fcbasic/fclabel.component';
export * from './fcbasic/fcline.component';
export * from './fcbasic/fclink.component';
export * from './fcbasic/fclist.component';
export * from './fcbasic/fclong.component';
export * from './fcbasic/fcmany.component';
export * from './fcbasic/fcpagination.component';
export * from './fcbasic/fcpopover.component';
export * from './fcbasic/fcradio.component';
export * from './fcbasic/fcrate.component';
export * from './fcbasic/fcswitch.component';
export * from './fcbasic/fctable.component';
export * from './fcbasic/fctag.component';
export * from './fcbasic/fctext.component';
export * from './fcbasic/fctextarea.component';
export * from './fcbasic/fctime.component';
export * from './fcbasic/fctimeline.component';
export * from './fcbasic/fctitle.component';
export * from './fcbasic/fctooltip.component';
export * from './fcbasic/fctree.component';
export * from './fcbasic/fctree.component';
export * from './fcbasic/fctreeselect.component';
export * from './fcbasic/fcupload.component';

export * from './fclayout/index.module';
export * from './fclayout/fclayoutcol.component';
export * from './fclayout/fclayoutgroup.component';
export * from './fclayout/fclayoutrow.component';
export * from './fclayout/fclayoutpanel.component';

export * from './fclist/index.module';
export * from './fclist/fclistdata.component';
export * from './fclist/fclistmodal.component';

export * from './fcmodal/index.module';
export * from './fcmodal/fcmodalcard.component';
export * from './fcmodal/fcmodalinput.component';
export * from './fcmodal/fcmodallist.component';
export * from './fcmodal/fcmodallistsearch.component';

export * from './fcnav/index.module';
export * from './fcnav/fcnavbar.component';
export * from './fcnav/fcnavmenu.component';
export * from './fcnav/fcnavside.component';
export * from './fcnav/fcnavtab.component';
export * from './fcnav/fcnavtabcontent.directive';

export * from './fcprogress/index.module';
export * from './fcprogress/fcprogressbar.component';
export * from './fcprogress/fcprogresscircle.component';
export * from './fcprogress/fcprogresspercent.component';

export * from './fctlb/index.module';
export * from './fctlb/fctlbform.component';
export * from './fctlb/fctlblist.component';
export * from './fctlb/fctlblistitem.component';


export * from './fcchart/index.module';
export * from './fcchart/fcchartbar.component';
export * from './fcchart/fcchartline.component';
export * from './fcchart/fcchartpie.component';
